﻿import { createSearchChats } from '../domain/search/search-chats.js';

/**
 * search-service.js
 * Orchestrates chat search via the domain use case.
 */
export class SearchService {
  constructor({ gateway, fallbackSearch, normaliseResult } = {}) {
    if (!gateway || typeof gateway.searchChats !== 'function') {
      throw new Error('SearchService requires a gateway with searchChats');
    }

    this.gateway = gateway;
    this.searchChatsUseCase = createSearchChats({
      search: (query) => this.gateway.searchChats(query),
      fallbackSearch,
      normaliseResult,
    });
  }

  async searchChats(query) {
    return this.searchChatsUseCase({ query });
  }
}

if (typeof window !== 'undefined') {
  window.AgileProServices = window.AgileProServices || {};
  window.AgileProServices.SearchService = SearchService;
}

